var map = {
	"./globe-1-big.png": 3324,
	"./globe-1-dark-mobile.png": 1489,
	"./globe-1-dark.png": 1176,
	"./globe-1-mobile.png": 4514,
	"./globe-1.png": 9225
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7856;